import React from 'react';
import { addDaysToDate, formatDateRange, formatDateKey } from './dateUtils';
import style from './CalendarSidebar.module.sass';

// Left-hand sidebar: holds the "Job Calendar" title, week navigation,
// the date picker, the Change Log button, and the Seniors-only filter.
// Moving these controls off the top frees the entire vertical area for
// the day columns so more jobs are visible per day.
const CalendarSidebar = ({
  startDate,
  onPrevious,
  onNext,
  onToday,
  onDatePick,
  onShowChangeLog,
  seniorsOnly,
  onToggleSeniors
}) => {
  const endDate = addDaysToDate(startDate, 12); // 2 weeks minus Sunday

  const handleDateChange = (e) => {
    const date = new Date(e.target.value + 'T00:00:00');
    if (!isNaN(date)) onDatePick(date);
  };

  return (
    <div className={style.sidebar}>
      <h2 className={style.title}>Job Calendar</h2>

      <div className={style.dateRange}>
        {formatDateRange(startDate, endDate)}
      </div>

      <div className={style.navGroup}>
        <button className={style.navButton} onClick={onPrevious}>
          &larr; Previous Week
        </button>
        <button className={style.todayButton} onClick={onToday}>
          Today
        </button>
        <button className={style.navButton} onClick={onNext}>
          Next Week &rarr;
        </button>
      </div>

      <label className={style.fieldLabel}>
        Jump to week
        <input
          type="date"
          className={style.datePicker}
          value={formatDateKey(startDate)}
          onChange={handleDateChange}
        />
      </label>

      <label className={style.checkboxRow}>
        <input
          type="checkbox"
          checked={seniorsOnly}
          onChange={onToggleSeniors}
        />
        <span>Seniors only (S0&hellip;)</span>
      </label>

      <button className={style.changeLogButton} onClick={onShowChangeLog}>
        Change Log
      </button>
    </div>
  );
};

export default CalendarSidebar;
